// Modules
import { BrowserModule } from '@angular/platform-browser';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
// import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { LayoutModule } from './modules/layout/layout.module'; 
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';

// Components

import { AppComponent } from './app.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component'; 
import { Page404Component } from './components/page404/page404.component'; 

// Services
import { HttpHandlerService } from './services/http-handler.service'; 
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TokenInterceptor } from './services/token.interceptor'; 
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// global
import { Constants } from './models/constants'; 
import { SafeHtmlPipe } from './services/pipes/safe-html.pipe'; 
import { HomeModule } from './modules/home/home.module'; 
import { LoginService } from './services/login.service';
import { AppCoreService } from './services/app-core.service';
export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    // ForbiddenComponent,
    Page404Component,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    LayoutModule,
    NgbModule,
    NgxUiLoaderModule,
    NgSelectModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      maxOpened: 1
    }),
    NgxUiLoaderRouterModule,
    // NgxUiLoaderHttpModule
  ],
  providers: [
    HttpHandlerService,
    AppCoreService,
    LoginService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    Constants
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
